import { SkipperLinkAttributes, SkipperLinkCompositeQuestion, SkipperLinkVirtualQuestion } from '../types'
import { skipperLinkAttributesToCorrelationFinderQuestion } from './correlation-finder'
import { skipperLinkAttributesToVirtualQuestion } from './virtual-question'

export function skipperLinkCorrelationFinderVQAttributesFinalize(attributes: SkipperLinkAttributes) {
  attributes.questionType = 'cvq'
  attributes.title ??= 'chart'
  attributes.qtitle ??= 'Correlation finder'
  attributes['vq-qtitle'] ??= 'Virtual question'
  return attributes
}

export function skipperLinkAttributesToCorrelationFinderVQQuestion(
  attributes: SkipperLinkAttributes
): SkipperLinkCompositeQuestion {
  const vqAttributes: SkipperLinkAttributes = {}
  for (const key in attributes) {
    if (key.startsWith('vq-')) {
      vqAttributes[key.slice(3)] = attributes[key]
    }
  }
  const virtualQuestion: SkipperLinkVirtualQuestion = skipperLinkAttributesToVirtualQuestion(vqAttributes)

  const compositeQuestion: SkipperLinkCompositeQuestion = [
    virtualQuestion,
    prevQuestions => {
      const virtualQuestion = prevQuestions[0] as SkipperLinkVirtualQuestion

      const correlationFinderAttributes: SkipperLinkAttributes = {}
      for (const key in attributes) {
        if (!key.startsWith('vq-')) {
          correlationFinderAttributes[key] = attributes[key]
        }
      }

      const vqID = virtualQuestion.id
      if (!vqID) {
        // eslint-disable-next-line no-console
        console.error('Virtual question id is required for correlation finder question')
        return null
      }
      const vqUID = vqID.toUpperCase()
      correlationFinderAttributes['b-pattern'] = vqID

      virtualQuestion.answerVariants.forEach((_, index) => {
        correlationFinderAttributes[`b${index}-pattern`] = `${vqUID}A${index + 1}`
      })

      const correlationFinderQuestion = skipperLinkAttributesToCorrelationFinderQuestion(correlationFinderAttributes)
      return correlationFinderQuestion
    }
  ]

  return compositeQuestion
}
